interface LoaderProps {
  width?: string;
  height?: string;
}

export const Loader: React.FC<LoaderProps> = ({ width = '68px', height = '68px' }) => {
  return <div style={{ width, height }} className='loader'></div>;
};
